<template>
  <div v-if="type=='outlets_create' || type=='outlets_edit'">
    <!-- <div class="container-fluid">
      <b-row>
        <b-col md="4" class="py-4">
          <span><strong>STORE PROFILE</strong></span>
        </b-col>
        <b-col md="4" class="py-4">
        </b-col>
        <b-col md="4" class="py-4">
          <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" :value="1" :uncheckedValue="0" />
        </b-col>
      </b-row>
    </div> -->
  </div>
  <ol v-else class="breadcrumb">
    <li class="breadcrumb-item" v-for="(item, index) in list">
      <span class="active" v-if="isLast(index)">{{ showName(item) }}</span>
      <router-link :to="item" v-else>{{ showName(item) }}</router-link>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    },
    type: {
    }
  },
  methods: {
    isLast (index) {
      return index === this.list.length - 1
    },
    showName (item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label
      }
      if (item.name) {
        item = item.name
      }
      return this.$t(item.toLowerCase())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue